import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import { Link } from 'gatsby';
import React from 'react';
import { useStyles } from '../TrackPage';

interface TrackLoginStepProps {
  termsAccepted: boolean;
  onTermsChange: (accepted: boolean) => void;
  onLogin: () => void;
}

export const TrackLoginStep: React.FC<TrackLoginStepProps> = ({
  termsAccepted,
  onTermsChange,
  onLogin,
}) => {
  const styles = useStyles();

  return (
    <div>
      <Box>
        <FormControlLabel
          className={styles.accept}
          control={
            <Checkbox
              checked={termsAccepted}
              onChange={() => onTermsChange(!termsAccepted)}
              name="checkedB"
              color="primary"
            />
          }
          label={
            <Typography variant="body2" align="left">
              I have read and accept ErgZone's{' '}
              <Link to="/privacy">privacy policy</Link> and{' '}
              <Link to="/terms">terms</Link>.
            </Typography>
          }
        />
      </Box>
      <Button
        className={styles.button}
        disabled={!termsAccepted}
        variant="contained"
        color="primary"
        onClick={onLogin}
      >
        Login
      </Button>
    </div>
  );
};
